import { ProductsResponseOut } from '../../../store/api';
import { productConfig } from '../../../config';
import { http } from '../../../api/axios';

export const getBackIssues = async (productId: string) => {
    const DEFAULT_PAGE_LIMIT = 20;
    const { data } = await http.get<ProductsResponseOut>(productConfig().endpointBackIssues, {
        params: {
            limit: DEFAULT_PAGE_LIMIT
        },
        pathParams: { productId }
    });
    return data;
};
